import axios from "axios";
import { SERVER_URL } from "../const";



export const getClosures = async (iec_no, type_name, page, page_size) => {
  const token = localStorage.getItem('token');
    try {
      // Make a GET request to the API endpoint using Axios
      const response = await axios.get(`${SERVER_URL}/closures?iec_no=${iec_no}&type_name=${type_name}&page=${page}&page_size=${page_size}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
  
      return response.data; // You can modify this based on your response structure
    } catch (error) {
      // Handle errors
      console.error('Error:', error);
      throw error; // Rethrow the error if needed
    }
};

export const getClosureDetails = async (id) => {
  const token = localStorage.getItem('token');
  try {
    // Make a GET request to the API endpoint using Axios
    const response = await axios.get(`${SERVER_URL}/closures/${id}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    return response.data; // You can modify this based on your response structure
  } catch (error) {
    // Handle errors
    console.error('Error:', error);
    throw error; // Rethrow the error if needed
  }
};


export const CreateClosuresService = async (iec_no, type_name, formData) => {
  const token = localStorage.getItem('token');
  try {
    // Make a GET request to the API endpoint using Axios
    const response = await axios.post(`${SERVER_URL}/closures/process?iec_no=${iec_no}&type_name=${type_name}`, formData, {
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
    });

    return response.data; // You can modify this based on your response structure
  } catch (error) {
    // Handle errors
    console.error('Error:', error);
    throw error; // Rethrow the error if needed
  }
};

export const UpdateClosuresService = async (closure_id, formData) => {
  const token = localStorage.getItem('token');
  try {
    // Make a GET request to the API endpoint using Axios
    const response = await axios.put(`${SERVER_URL}/closures/${closure_id}`, formData, {
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
    });

    return response.data; // You can modify this based on your response structure
  } catch (error) {
    // Handle errors
    console.error('Error:', error);
    throw error; // Rethrow the error if needed
  }
};


export const deleteClosureDetails = async (id) => {
  const token = localStorage.getItem('token');
  try {
    // Make a GET request to the API endpoint using Axios
    const response = await axios.delete(`${SERVER_URL}/closures/${id}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    return response.data; // You can modify this based on your response structure
  } catch (error) {
    // Handle errors
    console.error('Error:', error);
    throw error; // Rethrow the error if needed
  }
};